import { writeStorage } from "@rehooks/local-storage";
import { useFormik } from "formik";
// import React, { useState } from "react";
// import { Col, Container, Row } from "react-bootstrap";
// import { Sidebar } from "../Components/Sidebar";
// import Form from "react-bootstrap/Form";
// import { BsInfoCircle } from "react-icons/bs";
// import { useFormik } from "formik";
// import axiosInstance from "../utils/axiosConfig";
// import toast from "react-hot-toast";
// import * as Yup from "yup";
// import { OtpModal } from "../Components/Modals/OtpModal";
// import Button from "react-bootstrap-button-loader";
// import { useAuth } from "../contexts/auth";
// import { writeStorage } from "@rehooks/local-storage";
// import { useLocation, useNavigate } from "react-router-dom";

// const validationSchema = Yup.object().shape({
//   email: Yup.string().required("Email is Required").email("Enter Valid Email"),
// });

// export const ConsentLogin = () => {
//   const [loader, setLoader] = useState(false);
//   const [showOtpModal, setShowOtpModal] = useState(false);
//   const [referenceId, setReferenceId] = useState("");
//   const [flowType, setFlowType] = useState("login"); // 'login' or 'register'
//   const [userNotFound, setUserNotFound] = useState(false);
//   const [isChecked, setIsChecked] = useState(false); // For T&C checkbox

//   const { onLogin } = useAuth();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const baseURL = process.env.REACT_APP_BASE_URL;

//   const loginForm = useFormik({
//     initialValues: { email: location.state?.email || "" },
//     validationSchema,
//     onSubmit: () => {
//       handleInitialSubmit();
//     },
//   });

//   // Step 1: User enters email and clicks "Proceed"
//   const handleInitialSubmit = () => {
//     setLoader(true);
//     setUserNotFound(false);
//     axiosInstance()
//       .post("api/generateOtp", {
//         emailId: loginForm.values.email,
//         otpType: "email_otp",
//         loginContext: "consent",
//         flow: "login", // First, try to log in
//         requestId: "req" + Date.now(),
//       })
//       .then((res) => {
//         if (res.data.code === 200) {
//           // User exists, proceed with login
//           setFlowType("login");
//           setReferenceId(res.data.referenceId);
//           setShowOtpModal(true);
//           toast.success("OTP Sent Successfully");
//         } else if (res.data.code === 1151) {
//           // User does NOT exist
//           setUserNotFound(true);
//         } else {
//           toast.error(res.data.message || "An error occurred.");
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//         toast.error(err?.response?.data?.detail || "Something went wrong");
//       })
//       .finally(() => {
//         setLoader(false);
//       });
//   };

//   // Step 2: User clicks "Signup" link after being told they're not found
//   const handleSignupClick = () => {
//     setLoader(true);
//     axiosInstance()
//       .post("api/generateOtp", {
//         emailId: loginForm.values.email,
//         otpType: "email_otp",
//         loginContext: "consent",
//         flow: "register", // Now, generate OTP for registration
//         requestId: "req" + Date.now(),
//       })
//       .then((res) => {
//         if (res.data.code === 200) {
//           // Proceed with registration
//           setFlowType("register");
//           setReferenceId(res.data.referenceId);
//           setShowOtpModal(true);
//           toast.success("OTP Sent for Signup");
//         } else {
//           // This might happen if user registered in another tab, for example
//           toast.error(res.data.message || "Could not start signup.");
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//         toast.error(err?.response?.data?.detail || "Something went wrong");
//       })
//       .finally(() => {
//         setLoader(false);
//       });
//   };

//   // Step 3: User submits OTP from the modal
//   const handleOtpSubmit = (otp) => {
//     setLoader(true);
//     const endpoint =
//       flowType === "login"
//         ? "api/corporateUserAuthLogin"
//         : "api/corporateUserLogin";

//     const payload =
//       flowType === "login"
//         ? {
//             emailId: loginForm.values.email,
//             otp: otp,
//             referenceId: referenceId,
//             requestId: "req" + Date.now(),
//           }
//         : {
//             emailId: loginForm.values.email,
//             emailIdOtp: otp,
//             referenceId: referenceId,
//             requestId: "req" + Date.now(),
//           };

//     axiosInstance()
//       .post(endpoint, payload)
//       .then((res) => {
//         if (res.data.code === 200) {
//           setShowOtpModal(false);
//           // writeStorage("user", JSON.stringify(res.data.data));
//           // writeStorage("token", res.data.data.accessToken);
//           // writeStorage("isLogin", true);
//           // onLogin("/home", res.data.data);
//           const userData = res.data.data; // Get the full user data object

//           // MODIFICATION START: Use the onLogin function from useAuth
//           // The onLogin function should handle storing data and navigation
//           onLogin(userData); 
//           // MODIFICATION END
//         } else {
//           toast.error(res.data.message || "Verification failed.");
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//         toast.error(err?.response?.data?.detail || "Something went wrong");
//       })
//       .finally(() => {
//         setLoader(false);
//       });
//   };

//   const resendOtp = () => {
//       // Resend based on the original flow determined
//       const flow = flowType === 'login' ? 'login' : 'register';
//       toast.promise(
//         axiosInstance().post("api/generateOtp", {
//             emailId: loginForm.values.email,
//             otpType: "email_otp",
//             loginContext: "consent",
//             flow: flow,
//             requestId: "req" + Date.now(),
//         }),
//         {
//             loading: 'Resending OTP...',
//             success: (res) => {
//                 if(res.data.code === 200) {
//                     setReferenceId(res.data.referenceId);
//                     return 'OTP Resent Successfully';
//                 }
//                 throw new Error(res.data.message || 'Failed to resend OTP');
//             },
//             error: 'Could not resend OTP.',
//         }
//     );
//   }

//   return (
//     <Container fluid className="px-4 py-5">
//       <Form noValidate onSubmit={loginForm.handleSubmit}>
//         <Row>
//           <Col md={4}>
//             <Sidebar gradientBg={true} fullHeight={true} />
//           </Col>
//           <Col md={6} className="offset-1 align-self-center">
//             <div className="form-head mb-5">
//               <h2 className="fw-bold mb-1">Corporate Login</h2>
//               <p className="opacity-75 mb-0">
//                 Enter your email to login to your account
//               </p>
//             </div>
//             <Row>
//               <Col md={12}>
//                 <Form.Group className="mb-3" controlId="emailId">
//                   <Form.Label className="d-flex align-items-center">
//                     Email ID
//                     <Button
//                       variant="link p-0 m-0 ms-3 lh-1 text-reset"
//                       title="Enter your corporate email ID"
//                     >
//                       <BsInfoCircle className="fs-6" />
//                     </Button>
//                   </Form.Label>
//                   <Form.Control
//                     type="email"
//                     name="email"
//                     placeholder="eg. john.doe@gmail.com"
//                     onChange={loginForm.handleChange}
//                     value={loginForm.values.email}
//                     onBlur={loginForm.handleBlur}
//                     isInvalid={
//                       loginForm.touched.email && !!loginForm.errors.email
//                     }
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {loginForm.errors.email}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
              
//               <Col md={12}>
//                 <Form.Group className="mb-4 mt-2">
//                   <Form.Check
//                     type="checkbox"
//                     id="terms-checkbox"
//                     label={
//                       <span>
//                         By clicking this button, I accept IBDIC&apos;s{" "}
//                         {/* <a
//                           href={`${baseURL}api/tc_master/privacy-policy/view`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="text-danger text-decoration-underline"
//                         > */}
//                           Privacy Policy {" "}
//                         {/* </a>{" "} */}
//                         and{" "}
//                         <a
//                           href={`${baseURL}api/tc_master/latest/view`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="text-danger text-decoration-underline"
//                         >
//                           Terms and Conditions
//                         </a>
//                       </span>
//                     }
//                     checked={isChecked}
//                     onChange={(e) => setIsChecked(e.target.checked)}
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md={12}>
//                 <div className="d-flex justify-content-center">
//                   <Button
//                     variant="dark"
//                     type="submit"
//                     className="px-5"
//                     loading={loader}
//                     disabled={!isChecked}
//                   >
//                     Proceed
//                   </Button>
//                 </div>
//               </Col>

//               {userNotFound && (
//                 <Col md={12} className="mt-3 text-center">
//                   <div className="alert alert-warning">
//                     User not found with this email. Please try again or{" "}
//                     <Button
//                       variant="link"
//                       className="p-0 text-decoration-underline"
//                       onClick={handleSignupClick}
//                       disabled={loader}
//                     >
//                       Signup
//                     </Button>
//                     .
//                   </div>
//                 </Col>
//               )}

//               <Col md={12} className="mt-3">
//                 <a
//                   href={`${baseURL}api/tc_master/eway-bill-consent/view`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <Button
//                     variant="primary"
//                     type="button"
//                     className="text-white d-block mx-auto"
//                   >
//                     Learn more about E-Way Bill Consent
//                   </Button>
//                 </a>
//               </Col>
//             </Row>
//           </Col>
//         </Row>
//       </Form>

//       <OtpModal
//         showOtpModal={showOtpModal}
//         setShowOtpModal={setShowOtpModal}
//         loginSubmit={handleOtpSubmit}
//         resendOtp={resendOtp}
//         loader={loader}
//       />
//     </Container>
//   );
// };



import React, { useState } from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import Form from "react-bootstrap/Form";
import toast from "react-hot-toast";
import { BsInfoCircle } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { OtpModal } from "../Components/Modals/OtpModal";
// import Button from "react-bootstrap-button-loader";
import { useAuth } from "../contexts/auth";
// import { useLocation } from "react-router-dom";
import { fetchAuthToken } from "../utils/getCognitoToken";
import axiosInstance from "../utils/axiosConfig";
import { Sidebar } from "../Components/Sidebar";
import { TermsConditionsModal } from "../Components/Modals/TermsConditionsModal";

const validationSchema = Yup.object().shape({
  email: Yup.string().required("Email is Required").email("Enter Valid Email"),
});

export const ConsentLogin = () => {
  const [loader, setLoader] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [referenceId, setReferenceId] = useState("");
  const [isChecked, setIsChecked] = useState(false); // For T&C checkbox

  // --- CHANGE 1: Introduce a single state to control the page's mode ---
  const [pageMode, setPageMode] = useState("login"); // 'login' or 'register'
  
  // The 'flowType' and 'userNotFound' states are no longer needed.
  // const [flowType, setFlowType] = useState("login");
  // const [userNotFound, setUserNotFound] = useState(false);

  const { onLogin } = useAuth();
  const location = useLocation();
  const baseURL = process.env.REACT_APP_BASE_URL;

  // --- CHANGE 2: The main submit handler is now unified and smarter ---
  const handleSubmit = (values) => {
    setLoader(true);
    
    if (pageMode === 'login') {
      // --- LOGIN FLOW ---
      axiosInstance()
        .post("auth/generate-otp", {
          emailId: values.email,
          otpType: "email_otp",
          loginContext: "consent",
          flow: "login", // Try to log in
          requestId: "req" + Date.now(),
        })
        .then((res) => {
          if (res.data.code === 200) {
            // User exists, proceed with login OTP
            setReferenceId(res.data.referenceId);
            setShowOtpModal(true);
            toast.success("OTP Sent Successfully", { position: "top-center" });
          } else if (res.data.code === 1151) {
            // **KEY CHANGE**: User does NOT exist, switch the page to register mode
            toast.error("Email not found. Please register to continue.", { position: "top-center" });
            setPageMode("register"); 
          } else {
            toast.error(res.data.message || "An error occurred.", { position: "top-center" });
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err?.response?.data?.detail || "Something went wrong", { position: "top-center" });
        })
        .finally(() => {
          setLoader(false);
        });
    } else {
      // --- REGISTER FLOW ---
      axiosInstance()
        .post("auth/generate-otp", {
          emailId: values.email,
          otpType: "email_otp",
          loginContext: "consent",
          flow: "register", // Generate OTP for registration
          requestId: "req" + Date.now(),
        })
        .then((res) => {
          if (res.data.code === 200) {
            setReferenceId(res.data.referenceId);
            setShowOtpModal(true);
            toast.success("OTP Sent for Signup", { position: "top-center" });
          }
          else if (res.data.code === 1152) {
            // User ALREADY exists, switch them back to login mode.
            toast.error(res.data.message, { position: "top-center" }); // Show the "already exists" message
            setPageMode("login"); // Switch the UI back to login

          } else {
            toast.error(res.data.message || "Could not start signup.", { position: "top-center" });
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err?.response?.data?.detail || "Something went wrong", { position: "top-center" });
        })
        .finally(() => {
          setLoader(false);
        });
    }
  };

  const loginForm = useFormik({
    initialValues: { email: location.state?.email || "" },
    validationSchema,
    onSubmit: handleSubmit, // The formik onSubmit now calls our unified handler
  });

  // The 'handleInitialSubmit' and 'handleSignupClick' functions are now combined into 'handleSubmit'.

  const handleOtpSubmit = (otp) => {
    setLoader(true);
    // --- CHANGE 3: Use pageMode to determine the endpoint and payload ---
    const endpoint =
      pageMode === "login"
        ? "auth/corporateUserAuthLogin"
        : "auth/corporateUserLogin";

    const payload =
      pageMode === "login"
        ? {
            emailId: loginForm.values.email,
            otp: otp,
            referenceId: referenceId,
            requestId: "req" + Date.now(),
          }
        : {
            emailId: loginForm.values.email,
            emailIdOtp: otp,
            referenceId: referenceId,
            requestId: "req" + Date.now(),
          };

    axiosInstance()
      .post(endpoint, payload)
      .then(async (res) => { // 1. Add the 'async' keyword here
        if (res.data.code === 200) {
          
          // --- START OF THE FIX ---
          // 2. Fetch the application access token, just like the old code did.
          const appAccessToken = await fetchAuthToken();
          if (appAccessToken) {
            // 3. Store it in localStorage with the key the interceptor is looking for.
            localStorage.setItem('access_token', appAccessToken);
          } else {
            // It's good practice to handle the case where the token fetch might fail.
            toast.error("Could not establish a secure session. Please try again.", { position: "top-center" });
            setLoader(false); // Stop the process if we can't get the token.
            return; 
          }
          // --- END OF THE FIX ---

          // 4. Now, proceed with the original logic.
          setShowOtpModal(false);
          onLogin(res.data.data);

        } else {
          toast.error(res.data.message || "Verification failed.", { position: "top-center" });
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err?.response?.data?.detail || "Something went wrong", { position: "top-center" });
      })
      .finally(() => {
        setLoader(false);
      });
  };

  // const getMasterDocId = (value) => {
  //   setmasterdocID(value);
  // };

  const resendOtp = () => {
    // --- CHANGE 4: Use pageMode to determine the resend flow ---
    const flow = pageMode; // It's already 'login' or 'register'
    toast.promise(
      axiosInstance().post("auth/generate-otp", {
        emailId: loginForm.values.email,
        otpType: "email_otp",
        loginContext: "consent",
        flow: flow,
        requestId: "req" + Date.now(),
      }),
      {
        loading: "Resending OTP...",
        success: (res) => {
          if (res.data.code === 200) {
            setReferenceId(res.data.referenceId);
            return "OTP Resent Successfully";
          }
          throw new Error(res.data.message || "Failed to resend OTP");
        },
        error: "Could not resend OTP.",
        position: "top-center" // Add position here
      }
    );
  };

  return (
    <Container fluid className="px-4 py-3">
      {/* Remove the Toaster component as we're setting position individually for each toast */}
      
      <Form noValidate onSubmit={loginForm.handleSubmit}>
        <Row>
          <Col md={3}>
            <Sidebar 
              gradientBg={true} 
              // fullHeight={true} 
              ctaText={'Learn more about E-Way Bill Consent'}
              ctaLink={`${baseURL}/static/tc/eway-bill-consent.pdf`}
            />
          </Col>
          <Col md={6} className="offset-1 align-self-center">
            {/* --- CHANGE 5: Make UI elements dynamic based on pageMode --- */}
            <div className="form-head mb-5">
              <h2 className="fw-bold mb-1">
                {pageMode === 'login' ? 'Corporate Login' : 'Corporate Signup'}
              </h2>
              <p className="opacity-75 mb-0">
                {pageMode === 'login' 
                  ? 'Enter your email to login to your account'
                  : 'Enter your email to create a new account'
                }
              </p>
            </div>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3" controlId="emailId">
                  <Form.Label className="d-flex align-items-center">
                    Email ID
                    <Button
                      variant="link p-0 m-0 ms-3 lh-1 text-reset"
                      title="Enter your corporate email ID"
                    >
                      <BsInfoCircle className="fs-6" />
                    </Button>
                  </Form.Label>
                  <div className="d-flex">
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="eg. john.doe@gmail.com"
                      onChange={loginForm.handleChange}
                      value={loginForm.values.email}
                      onBlur={loginForm.handleBlur}
                      isInvalid={
                        loginForm.touched.email && !!loginForm.errors.email
                      }
                      className="me-2"
                    />
                    <Button
                      variant="dark"
                      type="button" // 1. Change type to "button"
                      onClick={loginForm.handleSubmit} // 2. Add onClick to trigger Formik's handler
                      loading={loader}
                      disabled={loader || (pageMode === 'register' && !isChecked)}
                  >
                      {pageMode === 'login' ? 'Proceed' : 'Register'}
                  </Button>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {loginForm.errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              
              {/* --- CHANGE 6: Conditionally render the T&C checkbox --- */}
              {pageMode === 'register' && (
                <Col md={12}>
                  <Form.Group className="mb-4 mt-2">
                    <Form.Check
                      type="checkbox"
                      id="terms-checkbox"
                      label={
                        <span>
                          I accept IBDIC&apos;s{" "}
                          Privacy Policy and{" "}
                          <a
                            href={`${baseURL}/static/tc/terms-and-conditions.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-danger text-decoration-underline"
                          >
                            Terms and Conditions
                          </a>
                        </span>
                      }
                      checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)}
                    />
                  </Form.Group>
                </Col>
              )}

              {/* Button has been moved next to the email field */}

              {/* The old 'userNotFound' alert is no longer needed */}

              {/* Commented out as requested
              <Col md={12} className="mt-3">
                <a
                  href={`${baseURL}/static/tc/eway-bill-consent.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    variant="primary"
                    type="button"
                    className="text-white d-block mx-auto"
                  >
                    Learn more about E-Way Bill Consent
                  </Button>
                </a>
              </Col>
              */}
            </Row>
          </Col>
        </Row>
      </Form>

      {/* <TermsConditionsModal
        showTermsConditionsModal={showTermsConditionsModal}
        setShowTermsConditionsModal={setShowTermsConditionsModal}
        getMasterDocId={getMasterDocId}
        setIsChecked={setIsChecked}
      /> */}

      <OtpModal
        showOtpModal={showOtpModal}
        setShowOtpModal={setShowOtpModal}
        loginSubmit={handleOtpSubmit}
        resendOtp={resendOtp}
        loader={loader}
        otpContext="email"
      />
    </Container>
  );
};